/**
 * A web address as a person reads it: without the http(s):// scheme and
 * without a lone trailing slash ("https://pelda.hu/" → "pelda.hu"). For link
 * text only — the href keeps the full stored URL. "www." and any path stay.
 */
export function displayUrl(url: string): string {
  return url.trim().replace(/^https?:\/\//i, '').replace(/^([^/?#]+)\/$/, '$1');
}
